import React, {useCallback} from 'react';
import {useSelector} from 'react-redux';
import componentslist from './help/components/componentslist';
import LandingContainer from './landing/components/LandingContainer';
import TopNavBar from './landing/components/TopNavBar';
import LandingFooter from './landing/components/LandingFooter';
import HeroComponent from './landing/components/HeroComponent';
import {useParams} from 'react-router-dom';

export default function CustomPage({isEmbedded}){
    const params = useParams()
    const content =  useSelector(useCallback((state)=>{
        if(state.settings.aff_extra_tabs){
            const aff_extra_tabs = typeof  state.settings.aff_extra_tabs === "string" ? JSON.parse(state.settings.aff_extra_tabs) : state.settings.aff_extra_tabs
            const page = aff_extra_tabs.find((item) => item.id === params.page_id) || {};
            return page.content || []
        }
        return []
    },[params.page_id]))
    const isLoggedIn = useSelector(useCallback((state)=>{
       return state.settings.access_token
    },[]))
    if(!isEmbedded && !isLoggedIn){
            return   <LandingContainer>
                <TopNavBar/>
                <div className={'bg-dark'}>
                    <HeroComponent/>
                </div>
                <div className={'bg-white'}>
                    <div className={'container mx-auto py-4'}>
                        <div className={'my-4 card'}>
                            <div className="card-body">
                            {
                                content.map((item, index) => {
                                    const Cmp = componentslist[item.type];
                                    return <Cmp {...item.props} key={item.blockId}/>;
                                })
                            }
                            </div>
                        </div>
                    </div>
                </div>
                <LandingFooter/>
            </LandingContainer>
        }
        return (
            <div>
                {
                    content.map((item, index) => {
                        const Cmp = componentslist[item.type];
                        return <Cmp {...item.props} key={item.blockId}/>;
                    })
                }
            </div>
        );
}
